import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { endpoints } from 'src/environments/endpoints';
import { Dashboard } from '../../models/dashboard/Dashboard';

@Injectable({
  providedIn: 'root',
})
export class DashboardService {
  http = inject(HttpClient);

  getDashboard(): Observable<Dashboard> {
    const baseUrl = endpoints.dashboard;
    const url = `${baseUrl}/listar`;

    return this.http.get<Dashboard>(url);
  }
}
